export default "__VITE_PUBLIC_ASSET__9c61cc38__"